import React from 'react';
import ButtonCreateJourney from '@components/ui/ButtonCreateJourney';
import { ButtonCreateJourneyFixedPropsInterface } from './ButtonCreateJourneyFixedTypes';
import * as Styled from './ButtonCreateJourneyFixedStyles';

function ButtonCreateJourneyFixed({
  isMobile,
}: ButtonCreateJourneyFixedPropsInterface) {
  if (!isMobile) {
    return null;
  }

  return (
    <Styled.WrapperFixed>
      <ButtonCreateJourney fullWidth />
    </Styled.WrapperFixed>
  );
}

export default ButtonCreateJourneyFixed;
